import config from '../../config/config';
import AuthHeader from '../../helpers/AuthHeader';
import Param from '../../helpers/Param';

export const releasesService = {
  getNewReleases
};

function getNewReleases(date, pagination, sorted){
    return  config.live ? getNewReleasesLive(date, pagination, sorted) : getNewReleasesStatic();
}

function getNewReleasesLive(date, pagination, sorted){
  const { page, per_page } = pagination;
  const { id, desc } = sorted[0];
  const baseUrl = `${config.apis.orthus}/v1/new_releases?release_date=${date}&page=${page}&per_page=${per_page}&order_by=${id}&order_dir=${desc?'DESC':'ASC'}`;
  const options = {
    method: 'GET',
    headers: AuthHeader({'Content-Type': 'application/json'})
  };

  return fetch( baseUrl, options )
  .then( response => {
    return response.json();
  })
  .catch( error => {
    return Promise.reject(ex)
  })
}

function getNewReleasesStatic(mode) { 
    let baseUrl = `${config.apis.sales}/api/static/new_releases.json`;
    return fetch(baseUrl)
    .then(res=>{   
        return res.json()
    });
}
